import axiosInstance from '../lib/axios';

export const fetchArticles = async ({ categoryId, subcategoryId, search } = {}) => {
    const response = await axiosInstance.get('/admin/articles', {
        params: { categoryId, subcategoryId, search },
    });
    return response.data;
};

export const fetchArticleById = async (id) => {
    const response = await axiosInstance.get(`/admin/articles/${id}`);
    return response.data;
};

export const createArticle = async (articleData) => {
    try {
        const response = await axiosInstance.post('/admin/articles', articleData);
        return response.data;
    } catch (error) {
        console.error('Error creating article:', error);
        throw error;
    }
};

export const updateArticle = async (id, articleData) => {
    try {
        const response = await axiosInstance.put(`/admin/articles/${id}`, articleData);
        return response.data;
    } catch (error) {
        console.error('Error updating article:', error);
        throw error;
    }
};

export const deleteArticle = async (id) => {
    try {
        const response = await axiosInstance.delete(`/admin/articles/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error deleting article:', error);
        throw error;
    }
};
